import { createFileRoute } from "@tanstack/react-router";
import { TemplateBuilderPage } from "@/features/worktemplates/TemplateBuilderPage";

export const Route = createFileRoute("/_app/work/templates/$template")({ component: Page });

function Page() {
  const { template } = Route.useParams();
  return <TemplateBuilderPage templateKey={template} />;
}
